import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setShowSubscriptionModalDialog } from '../../actions/payment'
import SubscriptionModal from './SubscriptionModal'
const TRIAL_PERIOD_PLAN_NAME = 'TRIAL PERIOD'

const TrialCountdown = () => {
  const dispatch = useDispatch<any>()

  const currentSubscriptionPlan = useSelector(
    (state: RootState) => state.payment.currentSubscriptionPlan,
  )

  const isTrialPlan =
    currentSubscriptionPlan?.plan_name === TRIAL_PERIOD_PLAN_NAME
  const expiryDate = currentSubscriptionPlan?.end_date

  const showSubscriptionModalDialog = useSelector(
    (state: RootState) => state.payment.showSubscriptionModalDialog,
  )

  const isSubscriptionsLoadingInProgress = false

  useEffect(() => {
    setTimeLeft(calculateTimeLeft())
  }, [currentSubscriptionPlan])

  const calculateTimeLeft = () => {
    const expiry = new Date(currentSubscriptionPlan?.end_date!).getTime()
    const now = new Date().getTime()
    const difference = expiry - now

    let timeLeft: any = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
      }
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0 }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 60000)

    return () => clearInterval(timer)
  }, [expiryDate])

  const handleSubscriptionModalClose = () => {
    dispatch(setShowSubscriptionModalDialog(false))
  }

  return (
    <>
      {isTrialPlan && (
        <>
          {!isSubscriptionsLoadingInProgress && currentSubscriptionPlan ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                background:
                  'linear-gradient(0deg, #E5F0FF, #E5F0FF),linear-gradient(180deg, #FFFFFF -9.33%, #C8DFFF 44.26%);',
                angle: '-180 deg',
                borderRadius: '10px',
                padding: '10px',
              }}
            >
              <Typography
                sx={{
                  textAlign: 'center',

                  fontWeight: 500,
                  fontSize: '0.82rem',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  verticalAlign: 'middle',
                }}
              >
                Trial Countdown
              </Typography>
              <Box
                sx={{
                  justifyContent: 'center',
                  display: 'flex',
                }}
              >
                <Box
                  sx={{
                    justifyItems: 'center',
                    borderRight: '1px solid #FFFFFF',
                    background:
                      'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                    boxShadow: '0px 1px 2px 0px #0000000D',
                    width: 50,
                    borderRightWidth: '1px',
                    gap: '10px',
                    borderTopLeftRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    paddingTop: '6px',
                    paddingRight: '16px',
                    paddingBottom: '6px',
                    paddingLeft: '16px',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '1.82rem',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      background:
                        'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                      color: '#1705E5',
                      marginBottom: '2px',
                    }}
                  >
                    {timeLeft.days}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '10px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      verticalAlign: 'middle',
                    }}
                  >
                    Days
                  </Typography>
                </Box>
                <Box
                  sx={{
                    justifyItems: 'center',
                    borderRight: '1px solid #FFFFFF',
                    background:
                      'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                    boxShadow: '0px 1px 2px 0px #0000000D',
                    width: 50,
                    borderRightWidth: '1px',
                    gap: '10px',
                    borderTopLeftRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    paddingTop: '6px',
                    paddingRight: '16px',
                    paddingBottom: '6px',
                    paddingLeft: '16px',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '1.82rem',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      background:
                        'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                      color: '#1705E5',
                      marginBottom: '2px',
                    }}
                  >
                    {timeLeft.hours}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '10px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      verticalAlign: 'middle',
                    }}
                  >
                    Hours
                  </Typography>
                </Box>
                <Box
                  sx={{
                    justifyItems: 'center',
                    borderRight: '1px solid #FFFFFF',
                    background:
                      'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                    boxShadow: '0px 1px 2px 0px #0000000D',
                    width: 50,
                    borderRightWidth: '1px',
                    gap: '10px',
                    borderTopLeftRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    paddingTop: '6px',
                    paddingRight: '16px',
                    paddingBottom: '6px',
                    paddingLeft: '16px',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '1.82rem',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      background:
                        'radial-gradient(104.32% 152.71% at 50% 50%, rgba(221, 221, 221, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
                      color: '#1705E5',
                      marginBottom: '2px',
                    }}
                  >
                    {timeLeft.minutes}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '10px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      verticalAlign: 'middle',
                    }}
                  >
                    Minutes
                  </Typography>
                </Box>
              </Box>
              <Button
                fullWidth
                sx={{
                  textTransform: 'none',
                  border: '1px solid #1705E5',
                  background: '#1705E5',
                  color: '#F5F5F5',
                }}
                onClick={() => dispatch(setShowSubscriptionModalDialog(true))}
              >
                {'Subscribe Now'}
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <SubscriptionModal
            isOpen={showSubscriptionModalDialog}
            handleClose={handleSubscriptionModalClose}
          />
        </>
      )}
    </>
  )
}

export default TrialCountdown
